import { Provider } from 'react-redux';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { AuthProvider } from './providers/Authentication';
import StaticProvider from './providers/StaticProvider';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { AppRoutes } from './config/routes';
import { ConfigProvider } from 'antd';
import AppContainer from './components/containers/AppContainer';
import { MicroDataProvider } from './providers/data';
import { Resources } from './modules/inspection/resources';

function App() {
  const routers = createBrowserRouter(AppRoutes);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AuthProvider>
          <StaticProvider>
            <ConfigProvider>
              <AppContainer
                resources={[...Resources]}
                dataProvider={{
                  default: MicroDataProvider,
                  micro: MicroDataProvider
                }}
              >
                <RouterProvider router={routers}></RouterProvider>
              </AppContainer>
            </ConfigProvider>
          </StaticProvider>
        </AuthProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
